export default [
    {
        path: '',
        name: 'live.index',
        component: () => import('@/views/live/Index.vue'),
    },
];